// tslint:disable:ordered-imports
import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Channel} from '../models/channel';
import {Language} from '../models/language';

@Injectable()
export class ChannelService {

  /**
   * Load dependencies
   * @param {ApiService} apiService
   */
  constructor(private apiService: ApiService) {
  }

  /**
   * Fetch user channels from the API
   * @param {Language} language
   * @returns {Observable<any>}
   */
  getUserChannels(language: Language) {
    return this.apiService.get('Channel/GetUserChannels?languageId=' + language.id).map((res) => {
      if (res.values && res.values) {
        return res.values.map(value => new Channel(value));
      }
    });
  }

  /**
   * Fetch schedule channels from the API
   * @param {Language} languages
   * @returns {Observable<any>}
   */
  getScheduleChannels(languages: Language[]) {
    let languageIds = languages.map(language => language.id);
    return this.apiService.get('Channel/GetScheduleChannels?languageIds=' + languageIds.toString()).map((res) => {
      if (res.values && res.values) {
        return res.values.map(value => new Channel(value));
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/channel.service.ts